import { Component, OnInit, ChangeDetectorRef, ElementRef} from '@angular/core';


import { MatDialog ,MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {Router, ActivatedRoute} from "@angular/router";
import { ADM0008Class } from '../../../../../Class/ADM0008/adm0008-class';
import { ADM0008ServiceService } from '../../../../../Service/ADM0008/adm0008-service.service';
import { CommonService } from '../../../../../Service/common/common-service.service';
import{FileAttachmentClass}from '../../../../../Class/common/file-attachment/file-attachment-class';
import { Widget0004Component } from '../widget0004/widget0004.component';
import { ADM0009ServiceService } from '../../../../../Service/ADM0009/adm0009-service.service';
//import { ADM0008Class } from 'src/app/Class/ADM0008/adm0008-class';
//import { ADM0008Class } from '../../../../../src/app/Class/ADM0008/adm0008-class';
//import { ADM0008Class } from '../../../../../Class/ADM0008/adm0008-class';
//import { ADM0008ServiceService } from '../../../../../Service/ADM0008/adm0008-service.service';
//import { ADM0008ServiceService } from '../../../../../src/app/Service/ADM0008/adm0008-service.service';
@Component({
  selector: 'kt-greetings-list',
  templateUrl: './greetings-list.component.html',
  styleUrls: ['./greetings-list.component.scss']
})
export class GreetingsListComponent implements OnInit {
  widgetInnerHtml: string;
  ArrModule:any[]=[];
  subModulesSelected:any[]=[];
  selectedItem:any;
  selectedSubItem:any;
  ArrMainModule:any[]=[];
  lblCompanyCode: string;
  lblCompanyName: string;
  lblUserName: string;
  // Public properties	
  tblOtherDocDetailsRowIndex : number;
	tblOtherDocDetailsArray :Array<any>=[];
  tblOtherDocDetailsReportRowIndex : number;
	tblOtherDocDetailsReportArray :Array<any>=[];
  fieldArrayCount:any[];
  constructor(   private objADM0009ervice:ADM0009ServiceService,private route: ActivatedRoute,public dialogRef: MatDialogRef<GreetingsListComponent>,private changeDetectorRef: ChangeDetectorRef, private router: Router,  private objCommonService:CommonService,private ADM0008service:ADM0008ServiceService, 
    private elementRef:ElementRef) { }

  ngOnInit() {
    this.widgetInnerHtml = "";

  }
  ngAfterViewInit()
  {
 
  this.route.queryParams.subscribe(params => {
    this.LoadList()
   

    })
  }
  // tblOtherDocDetailsEdit(field){
   
    
  //     var url = field.PageUrl;

  //     this.router.navigate([url], { queryParams: { } });   
  //     this.changeDetectorRef.detectChanges();
  //     }
    
  //     tblOtherDocDetailsReportEdit(field){
       
  //       var url = field.PageUrl;

  //       this.router.navigate([url], { queryParams: { } });   
  //       this.changeDetectorRef.detectChanges();
  //         }

         
  //         tblOtherDocDetailsRemove(field){
  //           debugger
  //           this.tblOtherDocDetailsRowIndex=null;
  //           const index = this.tblOtherDocDetailsArray.indexOf(field);
  //          var id=field.FavoriteId;

  //           this.ADM0008service.Delete(id).subscribe(data=>{
  //             if(data)
  //             {
                
  //             }
  //           });
         
  //           this.tblOtherDocDetailsArray.splice(index,1);
      
  //           this.changeDetectorRef.detectChanges();
  //         }
  //         tblOtherDocDetailsRemoveReport(field){
           
  //           this.tblOtherDocDetailsReportRowIndex=null;
  //           const index = this.tblOtherDocDetailsReportArray.indexOf(field);
  //           var id=field.FavoriteId;
  //           this.ADM0008service.Delete(id).subscribe(data=>{
              
  //           });
       
  //           this.tblOtherDocDetailsReportArray.splice(index,1);
      
  //           this.changeDetectorRef.detectChanges();
  //         }
 
          onLoad()
  {

    this.ADM0008service.LoadFind().subscribe(data=>{     
    this.tblOtherDocDetailsArray = data.ADM0008List as ADM0008Class[];     
    this.changeDetectorRef.detectChanges();
    })

    this.ADM0008service.LoadFindReport().subscribe(data=>{     
      this.tblOtherDocDetailsReportArray = data.ADM0008ListReport as ADM0008Class[];     
      this.changeDetectorRef.detectChanges();
      })
  
  }
  Close()
  {
    
    this.dialogRef.close(`${""}`);
  }

  LoadList()
  {

    this.objADM0009ervice.LoadGreetings().subscribe(list=>{ 
      this.fieldArrayCount=list;		

    // this.objWIDGET0004ervice.GetCountAnnouncement().subscribe(data=>{  
   
    //   this.tblAnnouncementDetailsArray = data.WIDGET0004List ;    
      
      this.changeDetectorRef.detectChanges();
      })
  }

}
